import React, {Component} from "react"
import {injectIntl} from "react-intl"
import {ACTION_QUERY_COUNTRY_LIST_LOADING, calibrationStatusMap, getGender} from "../constants"
import educations from "./form/wrongEductions.json"
import {connect} from "react-redux"

function mapStateToProps(state, ownProps) {
  const countries = state.countries || {data: []}
  const usersWithStatus = state.usersWithStatus || {data: []}

  return {
    countries, usersWithStatus
  }
}

const mapDispatchToProps = {
  queryCountries: function () {
    return {
      type: ACTION_QUERY_COUNTRY_LIST_LOADING
    }
  }
}

class UserInfoTable extends Component {

  componentWillMount() {
    this.props.queryCountries()

  }

  render() {

    const users = this.props.usersWithStatus.data

    const intl = this.props.intl
    const format = intl.formatMessage

    const countryMap = {}
    this.props.countries.data.forEach((it) => {
      countryMap[it.code] = it.label
    })

    const educationMap = {}
    const educationsData = educations//this.props.educations.data
    educationsData.forEach((it) => {
      educationMap[it.code] = it.label
    })

    const user = this.props.user || {}

    const country = countryMap[user.country] || ""
    const education = user.education? format({id:'education.' + user.education}): ''

    console.log(`users`)
    console.log(users)
    let calibrationStatus = '-'
    if(user.id){
      let status = (_.find(users, u=>u.id === user.id) || {}).calibrationStatus || 'NONE'
      calibrationStatus = format({id:`calibration.status.${status}`})
    }

    return (
      <div className="row m-l-xs" style={{fontSize:'13px', fontFamily:'Roboto, Medium'}}>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-xs-12">
              {user.name} {user.enterpriseReference ? `(REF: ${user.enterpriseReference})` : ''}
            </div>
          </div>

          <div className="row">
            <div className="col-xs-4">{format({id:'age'})}:</div>
            <div className="col-xs-8">{user.age}</div>
          </div>

          <div className="row">
            <div className="col-xs-4">{format({id:'gender'})}:</div>
            <div className="col-xs-8">{getGender(user.isMale, intl)}</div>
          </div>

          <div className="row">
            <div className="col-xs-4">{format({id:'country'})}:</div>
            <div className="col-xs-8">{country}</div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-xs-12" style={{color:"#ffffff"}}>-</div>
          </div>
          <div className="row">
            <div className="col-xs-4">{format({id:'education'})}:</div>
            <div className="col-xs-8">{education}</div>
          </div>
          <div className="row">
            <div className="col-xs-4">{format({id:'emailAddress'})}:</div>
            <div className="col-xs-8">{user.emailAddress}</div>
          </div>
          <div className="row">
            <div className="col-xs-4">{format({id:'calibration.status'})}:</div>
            <div className="col-xs-8">{calibrationStatus}</div>
          </div>

        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UserInfoTable))



// WEBPACK FOOTER //
// ./src/components/UserInfoTable.js